module.exports = __webpack_public_path__ + "media/Heat_IN.fee73a84.mp4";